import React from 'react';
import ServiceListItem from '../ServiceListItem';
import JsxHelper from '../../Helpers/JsxHelper';
import LookupText from '../../Elements/LookupText';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';
import ShowNameComponent from '../../Elements/ShowNameComponent';
import CurrencyService from '../../Services/CurrencyService';

export default class AuditsServiceItem extends ServiceListItem {
  static FieldsToShowInListTable = [
    ...ServiceListItem.generalTab,
    {
      tabName: 'Fieldwork',
      tabLabel: 'Fieldwork',
      icon: 'fa-solid fa-briefcase',
      data: [
        { name: 'TimeConstraints', label: 'Visit Time Constraints (days/hours/etc)' },
        { name: (item) => Array.isArray(item.SpecialLocations) ? item.SpecialLocations.join(', ') : (item.SpecialLocations || ''), label: 'Special Locations' },
        { name: (item) => Array.isArray(item.LocationType) ? item.LocationType.join(', ') : (item.LocationType || ''), label: 'Location Type' },
        { name: 'LocationTypeDetails', label: 'Location Type Details', width: TabListTableCellWidthEnum.TwoLines },
        { name: 'LocationListSource', label: 'Location List Source' },
      ],
    },
    {
      tabName: 'ProgramApproach',
      tabLabel: 'Program Approach',
      icon: 'fa-solid fa-diagram-project',
      data: [
        { name: (item) => Array.isArray(item.InStoreOrOnline) ? item.InStoreOrOnline.join(', ') : (item.InStoreOrOnline || ''), label: 'In-store, Online, or Phone' },
        { name: 'NumLocations', label: 'Number of Locations' },
        { name: 'NumItemsPricesPerLocation', label: 'Number of Items/Prices per Location?' },
        { name: (item) => JsxHelper.YesNo(item.PriceAccuracySlarequired), label: 'Price Accuracy SLA Required?' },
        { name: 'PriceAccuracySladescription', label: 'If yes, please describe' },
        { name: (item) => JsxHelper.YesNo(item.CompetitorPricingStudy), label: 'Competitor Pricing Study?' },
        { name: 'NumCompetitors', label: 'If yes, number of competitors' },
        { name: 'AnnouncedOrUnannounced', label: 'Announced or Unannounced?' },
        { name: (item) => JsxHelper.YesNo(item.LetterOfAuthorizationRequired), label: 'Letter of Authorization Required?' },
        { name: (item) => JsxHelper.YesNo(item.PhotosReqd), label: 'Photos Required?' },
        { name: 'PhotosDescription', label: 'Description of Photos Required' },
        { name: (item) => JsxHelper.YesNo(item.UpcjanianscanRequired), label: 'UPC/JAN/IAN Scan Required?' },
        { name: 'NumDaysInField', label: 'Number of Days in Field?' },
        { name: (item) => Array.isArray(item.PricingAspectsToEvaluate) ? item.PricingAspectsToEvaluate.join(', ') : (item.PricingAspectsToEvaluate || ''), label: 'What Pricing Aspects Should be Evaluated?' },
        { name: 'ProductType', label: 'Product Type' },
        { name: (item) => Array.isArray(item.DirectedPricingApproach) ? item.DirectedPricingApproach.join(', ') : (item.DirectedPricingApproach || ''), label: 'Directed Price Gathering Approach' },
        { name: 'DirectedPricingApproachDetails', label: 'Other Directed Pricing Approach Details', width: TabListTableCellWidthEnum.TwoLines },
        { name: (item) => JsxHelper.YesNo(item.DescriptionGatheringRequired), label: 'Description Gathering Required?' },
        { name: (item) => Array.isArray(item.KpisBehaviorRequirements) ? item.KpisBehaviorRequirements.join(', ') : (item.KpisBehaviorRequirements || ''), label: "Any Specific KPI's or Behavior Requirement?" },
      ],
    },
    {
      tabName: 'Purchase',
      tabLabel: 'Purchase',
      icon: 'fa-solid fa-cart-shopping',
      data: [
        { name: (item) => JsxHelper.YesNo(item.PurchaseReqd), label: 'Purchase Required?' },
        { name: (item) => <ShowNameComponent serviceFunction={CurrencyService.GetCurrencyNameById} id={item.PurchaseAmtCurId} />, label: 'Purchase Amount Currency' },
        { name: 'PurchaseAmt', label: 'Minimum Purchase Amount' },
        { name: 'MaxPurchaseAmt', label: 'Maximum Purchase Amount' },
        { name: 'PurchaseDesc', label: 'Item Required to Be Purchased', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Validation',
      tabLabel: 'Validation',
      icon: 'fa-solid fa-camera',
      data: [
        { name: 'NumPhotographsReqd', label: 'Number of Photographs Required' },
        { name: (item) => JsxHelper.YesNo(item.StorefrontPhotoRequired), label: 'Storefront Photo Required?' },
        { name: (item) => JsxHelper.YesNo(item.GeoLocationTagging), label: 'GEO Location Tagging' },
        { name: 'OtherPhotosDesc', label: 'Describe other Photographs Required', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'DataCapture',
      tabLabel: 'Data Capture',
      icon: 'fa-solid fa-database',
      data: [
        { name: 'PricingAuditDataCaptureMethod', label: 'Data Capture Method' },
        { name: 'OtherDataCaptureMethod', label: 'Other Data Capture Method Description' },
      ],
    },
    {
      tabName: 'Demographics',
      tabLabel: 'Demographics',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'MinAge', label: 'Minimum Age' },
        { name: 'MaxAge', label: 'Maximum Age' },
        { name: (item) => <LookupText lookupId={17} value={item.GenderCode} />, label: 'Gender' },
        { name: 'OtherDemographicRequirements', label: 'Other Demographic Requirements' },
      ],
    },
    ...ServiceListItem.commonEndTabs,
  ];
}
